import { combineReducers } from 'redux';
import PickupRequest from './PickupRequest';
import OrderBreakup from './OrderReducer';
import CommonReducer from './CommonReducer';

export default combineReducers({
    Pickup: PickupRequest,
    Order: OrderBreakup,
    Common: CommonReducer
})